import { z } from 'zod';

import { BaseWidgetSchema } from './BaseWidgetSchema';
import { WidgetType } from '../../utils/widgetsUtils';

export const OpenDiscussionWidgetStaticSchema = BaseWidgetSchema(WidgetType.OpenDiscussion).extend({
  enabledPictureUpload: z.boolean(),
  enabledMultiplePosts: z.boolean()
});

export type OpenDiscussionWidgetStaticSchemaType = z.infer<typeof OpenDiscussionWidgetStaticSchema>;
